export const name = "FORMAT_DATETIME";
export const summary = `Formats a \`DATETIME\` value according to a specified format string.`;
export const reference = `
## FORMAT_DATETIME

Formats a \`DATETIME\` value according to a specified format string.

\`\`\`
FORMAT_DATETIME(format_string, datetime_expr)
\`\`\`

### Description

Formats a \`DATETIME\` value according to a specified format string.


### Definitions

- \`format_string\`: A \`STRING\` value that contains the format elements to use with\`datetime_expr\`.
- \`datetime_expr\`: A \`DATETIME\` value that represents the date and time to format.


### Return Data Type

\`STRING\`


### Examples



\`\`\`
SELECT
  FORMAT_DATETIME("%c", DATETIME "2008-12-25 15:30:00")
  AS formatted;

/*--------------------------*
 | formatted |
 +--------------------------+
 | Thu Dec 25 15:30:00 2008 |
 *--------------------------*/
\`\`\`



\`\`\`
SELECT
  FORMAT_DATETIME("%b-%d-%Y", DATETIME "2008-12-25 15:30:00")
  AS formatted;

/*-------------*
 | formatted |
 +-------------+
 | Dec-25-2008 |
 *-------------*/
\`\`\`



\`\`\`
SELECT
  FORMAT_DATETIME("%b %Y", DATETIME "2008-12-25 15:30:00")
  AS formatted;

/*-------------*
 | formatted |
 +-------------+
 | Dec 2008 |
 *-------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/datetime_functions
`;
